import {FontAwesomeIcon as Icon} from '@fortawesome/react-fontawesome'
import {number, translate} from 'filters'
import React from 'react'
import moment from 'moment'
import {history} from '../../../Router/Router'

export type ClaimStatisticValue = 'last-month' | 'current-month' | 'current-year' | 'last-year' | 'all-time'

type ClaimStatisticRange = Array<{
  label: string, value: ClaimStatisticValue
}>

type ClaimedVehiclesStatisticState = {
  statisticOptions: ClaimStatisticRange
  selectedOption: ClaimStatisticValue
  claimedCount: number
  loading: boolean
}

class ClaimedVehiclesStatistic extends React.Component<{}, ClaimedVehiclesStatisticState> {
  constructor(props: {}) {
    super(props)

    this.state = {
      statisticOptions: [
        {label: translate('letzter Monat'), value: 'last-month'},
        {label: translate('aktueller Monat'), value: 'current-month'},
        {label: translate('aktuelles Jahr'), value: 'current-year'},
        {label: translate('letztes Jahr'), value: 'last-year'},
        {label: translate('insgesamt'), value: 'all-time'}
      ],
      selectedOption: 'current-month',
      claimedCount: 0,
      loading: false
    }
  }

  componentDidMount() {
    this.fetchClaimedCount(this.state.selectedOption)
  }

  fetchClaimedCount = async (filter: ClaimStatisticValue) => {
    this.setState({loading: true})
    try {
      const response = await window.axios.post('/performance-indicators/claimed', {filter})
      this.setState({
        claimedCount: response.data?.indicator || 0,
        loading: false
      })
    } catch (err) {
      this.setState({loading: false})
    }
  }

  showClaimed = async (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation()

    if (this.state.selectedOption === 'all-time') {
      return history.push('/claimed-vehicles')
    }

    let start = moment().startOf('month')
    let end = moment().endOf('month')

    if (this.state.selectedOption === 'last-month') {
      start = moment().subtract(1, 'month').startOf('month')
      end = moment().subtract(1, 'month').endOf('month')
    }

    if (this.state.selectedOption === 'current-year') {
      start = moment().startOf('year')
      end = moment().endOf('year')
    }

    if (this.state.selectedOption === 'last-year') {
      start = moment().subtract(1, 'year').startOf('year')
      end = moment().subtract(1, 'year').endOf('year')
    }

    // Navigate to claimed vehicles page with date filter
    return history.push(`/claimed-vehicles?from=${start.format('YYYY-MM-DD')}&to=${end.format('YYYY-MM-DD')}`)
  }

  render() {
    return (
      <div className='statistic_box rounded' onClick={this.showClaimed}>
        <div className='statistic_box_body'>
          <h2>{translate('Gekaufte Fahrzeuge')}</h2>
          <p>{translate('Anzahl Fahrzeuge, die Sie gekauft haben.')}</p>
          <div className='stat'>
            <Icon icon='trophy' className='fa-4x mr-4 fa-fw' />
            <span className='font-semibold text-2xl'>
              {this.state.loading ? '...' : number(this.state.claimedCount, 0, 'x')}
            </span>
          </div>
          <div>
            <select value={this.state.selectedOption} className={'bg-teal-200 text-teal-800'} onClick={e => {
              e.preventDefault()
              e.stopPropagation()
            }} onChange={async (e) => {
              const newValue = e.target ? e.target.value as ClaimStatisticValue : 'current-month'
              this.setState({selectedOption: newValue})
              await this.fetchClaimedCount(newValue)
            }}>
              {this.state.statisticOptions.map((option) => (
                <option key={option.value} value={option.value}>{option.label}</option>
              ))}
            </select>
          </div>
        </div>
      </div>
    )
  }
}

export default ClaimedVehiclesStatistic
